import { animations } from './animations';
import { mainMenu } from './mainMenu';
import { searchDialog } from './searchDialog';
import { homepageBanner } from './homepageBanner';
import { playPauseVideo } from './playPauseVideo';
import { share } from './share';
import { accordions } from './accordions';
import { anchorMenu } from './anchorMenu';

wp.domReady(() => {
  accordions();
  anchorMenu();
  animations();
  mainMenu();
  playPauseVideo();
  searchDialog();
  homepageBanner();
  share();

  // Open external links and file links in a new tab
  document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, window.location.href);
    const isExternal = url.hostname !== window.location.hostname;

    const fileExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.zip'];
    const isFileLink = fileExtensions.some(ext => url.pathname.toLowerCase().endsWith(ext));

    if (isExternal || isFileLink) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});
